module.exports = __webpack_public_path__ + "static/media/banner-keyman.17365b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-keyman.png
// module id = 1254
// module chunks = 1